import React from 'react';

const Container = ({ children, className }) => {
  return (
    <div className={`${className} mx-auto 2xl:container px-3`}>
      {children}
    </div>
  );
};

export default Container;
